import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { resolveReturnPathForLogin } from '../../utils/authSessionExpired';
import LoadingOverlay from '../common/LoadingOverlay';

const ADMIN_ROLE = 'admin_user';

/**
 * Requires a signed-in admin. Guests go to login (with return path);
 * signed-in non-admins go home.
 */
export default function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingOverlay />;
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: resolveReturnPathForLogin(location),
        }}
      />
    );
  }

  if (user.Role !== ADMIN_ROLE) {
    return <Navigate to="/" replace />;
  }

  return children;
}
